<!-- <div class="container mt-4">
  <h2>Nueva Deuda para Cliente {{ clienteId }}</h2>

  <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div formArrayName="productos">
      <div *ngFor="let p of productos.controls; let i = index" [formGroupName]="i" class="card mb-2 p-3">
        <div class="row">
          <div class="col-md-6">
            <label>Producto</label>
            <select class="form-select" formControlName="productoId" required>
              <option value="">Seleccionar</option>
              <option *ngFor="let prod of productosDisponibles" [value]="prod.productoId">
                {{ prod.nombre }} - ${{ prod.precio }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label>Cantidad</label>
            <input type="number" class="form-control" formControlName="cantidad" min="1">
          </div>
          <div class="col-md-3 d-flex align-items-end">
            <button type="button" class="btn btn-danger" (click)="removerProducto(i)">Eliminar</button>
          </div>
        </div>
      </div>
    </div>

    <button type="button" class="btn btn-secondary mb-3" (click)="agregarProducto()">+ Agregar Producto</button>
    <button type="submit" class="btn btn-primary" [disabled]="loading">Guardar Deuda</button>
  </form>
</div> -->
<div class="container py-4">

  <!-- Encabezado con volver -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <button class="btn btn-outline-secondary" (click)="volverAtras()">
      <i class="fa-solid fa-arrow-left"></i> Volver
    </button>
    <h3 class="text-primary mb-0">
      <i class="fa-solid fa-file-invoice-dollar me-2"></i>Nueva Deuda
    </h3>
    <div></div> <!-- Espaciador para alinear -->
  </div>

  <!-- Error -->
  <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div *ngIf="productos.length === 0" class="alert alert-info text-center">
      <i class="fa-solid fa-info-circle me-2"></i>
      Agregue su primer producto por favor, presione el botón <strong>Agregar Producto</strong>.
    </div>
    <!-- Lista de productos -->
    <div formArrayName="productos">
      <div *ngFor="let p of productos.controls; let i = index" [formGroupName]="i" class="card border-0 shadow-sm mb-3">
        <div class="card-body">
          <div class="row g-3 align-items-end">

            <div class="col-md-5">
              <label class="form-label">Producto</label>
              <select class="form-select" formControlName="productoId" required>
                <option value="">Seleccionar producto</option>
                <option *ngFor="let prod of productosDisponibles" [value]="prod.productoId">
                  {{ prod.nombre }}
                </option>
              </select>
            </div>

            <!-- <div class="col-md-3">
              <label class="form-label">Precio Unitario</label>
              <input type="number" class="form-control" formControlName="precio" min="0" required>
            </div> -->
            <div class="col-md-3">
              <label class="form-label">Cantidad</label>
              <input type="number" class="form-control" formControlName="cantidad" min="1" required>
            </div>
            <div class="col-md-1 text-end">
              <button type="button" class="btn btn-outline-danger" (click)="removerProducto(i)">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Acciones -->
    <div class="d-flex justify-content-between mt-4">
      <button type="button" class="btn btn-outline-secondary" (click)="agregarProducto()">
        <i class="fa-solid fa-plus"></i> Agregar Producto
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="loading">
        <i class="fa-solid fa-floppy-disk"></i> Guardar Deuda
      </button>
    </div>
  </form>
</div>
